(function () {
  const section = document.querySelector('.section-header');
  if (!section) return;

  const HIDE_THRESHOLD = 25;
  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateHeader() {
    const scrollY = window.scrollY;

    if (scrollY < HIDE_THRESHOLD) {
      section.classList.remove('header--scroll-hidden');
    } else if (scrollY > lastScrollY) {
      section.classList.add('header--scroll-hidden');
    } else if (scrollY < lastScrollY) {
      section.classList.remove('header--scroll-hidden');
    }

    lastScrollY = scrollY;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    },
    { passive: true }
  );

  updateHeader();
})();
